import $ from 'jquery';
import _ from 'lodash';

import 'cleave.js';
import './node_modules/cleave.js/src/addons/phone-type-formatter.us';

import FormValidator from './FormValidator';
import EC from './ExpressionComparator';
import 'bootstrap/dist/js/bootstrap';

class ContactController{
    constructor(){
        this.initCleave();

        this.hasValidated =false;
        let validationFields = $('.doValidate');
        this.validator = new FormValidator(validationFields);

        this.addEventListeners();
    }
    initCleave(){
        try{
            new Cleave('#phone', {
                delimiters: ['(', ')', '-'],
                blocks: [0, 3, 3, 4],
                numericOnly: true
            });
            new Cleave('#duedate', {
                date: true,
                datePattern: ['m', 'd', 'Y']
            });
        }catch(e){console.log(e);}
    }

    addEventListeners = function(){
        let instance = this;

        $('.doValidate').on('change keyup',(function(e){
            if(instance.hasValidated){
                if($(this).hasClass('radio')){
                    instance.validator.validateRadioField(this);
                }else if($(this).attr('type') == 'checkbox'){
                    instance.validator.validateCheckbox(this);
                }else{
                    instance.validator.validateField(this);
                }
            }
        }));

        /****** contact form submit ********/
        $('.contactForm').submit(function(e){
            e.preventDefault();

            instance.clearGeneralErrorMessage();

            if(instance.validator.validate()){
            // if(true){
                $('.btnSubmit').button('loading');
                instance.clearAllErrorMessages();

                var options = {
                    'name' : $('#name').val(),
                    'email' : $('#email').val(),
                    'phone' : $('#phone').val(),
                    'location' : $('#location').val(),
                    'duedate' : $('#duedate').val(),
                    'userMessage' : $('#userMessage').val(),
                    'g-recaptcha-response' : $('[name="g-recaptcha-response"]').val()
                };
                $.post('./processContactForm.php',options,function(data){
                    $('.btnSubmit').button('reset');

                    data = JSON.parse(data);
                    if(data.status=='success'){
                        //window.location.href = '../my-home/';
                        instance.showGeneralSuccessMessage(data.msg);
                        $('.btnSubmit').hide();
                        $('.g-recaptcha').hide();
                        $('.g-recaptcha-response').hide();
                    }else if(data.status == 'generalError'){
                        instance.showGeneralErrorMessage(data.msg);
                    }else{
                        instance.handleValidationError(data);
                    }
                });
            }
            instance.hasValidated = true;
            return false;
        });
    }

    handleValidationError = function(data){
        let instance = this;
        let firstErrorElementID = null;
        data.errorFields.forEach(function(obj,index){

            for(var key in data.errorFields[index]){

                if(!firstErrorElementID) firstErrorElementID = key;

                var value = data.errorFields[index][key];

                var error_field = $('#'+key)[0];
                if(error_field.tagName.toLowerCase() === 'input'){
                    instance.validator.showError(error_field,value);
                }else if(error_field.tagName.toLowerCase() === 'div'){
                    instance.validator.showRadioError(error_field,value);
                }else if(error_field.tagName.toLowerCase() === 'select'){
                    instance.validator.showError(error_field,value);
                }else{
                    instance.validator.showError(error_field,value);
                }


                //var error_field = $(this[key+'_group']).find('.form-control')[0];
                //this.formValidator.showError(error_field,value);
            }
        });

        this.scrollToFirstErrorElement(firstErrorElementID);
    }

    scrollToFirstErrorElement = function(firstErrorElementID){
        var errorElementYPos = $('#'+firstErrorElementID).offset().top - 70;
        $("html, body").animate({ scrollTop: errorElementYPos + 'px' }, "fast");
    }
    clearAllErrorMessages = function(){
        $('.errorMessage').empty();
        this.clearGeneralSuccessMessage();
        this.clearGeneralErrorMessage();
    }

    showGeneralErrorMessage(msg){
        $('.generalErrorMsg').html(msg);
    }
    showGeneralSuccessMessage(msg){
        $('.successMsg').html(msg);
    }
    clearGeneralErrorMessage(msg){
        $('.generalErrorMsg').empty();
    }
    clearGeneralSuccessMessage(msg){
        $('.successMsg').empty();
    }
}

export default new ContactController();



/** WEBPACK FOOTER **
 ** C:/Apache2/htdocs/shutterbabee/contact/controls/ContactController.js
 **/